import { Button, Checkbox, DatePicker, Form, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import DeleteBoooking from "./components/DeleteBoooking";
import CreateBooking from "./components/CreateBooking";
import ConfirmBooking from "./components/ConfirmBooking";
import Moment from "react-moment";
import moment from "moment";
import logo from "../../../assets/images/logo-icon.png";
import { BsCalendar4Event, BsCheckSquare } from "react-icons/bs";
import { IoIosLogIn } from "react-icons/io";
import Toastify from "toastify-js";
import { Link } from "react-router-dom";
import UpdateWip from "./components/UpdateWip";
import fetchDataTrace from "../../../services/fetchDataTrace";
import { AuthContext } from "../../../contexts/AuthContext";
import RescheduleBooking from "./components/RescheduleBooking";
import { formatNumber } from "../../../utils/formatNumber";
import DetailsPanel from "./components/DetailsPanel";
import { pusher } from "../../..";
import { RiFilterOffLine } from "react-icons/ri";
import { GoLocation } from "react-icons/go";

const { RangePicker } = DatePicker;
export default function WallBookings() {
  const { user, token, expire } = useContext(AuthContext);

  const [createModal, setCreateModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [wipModal, setWipModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [bookings, setBookings] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [showRange, setShowRange] = useState(false);

  const start = moment(new Date()).format("YYYYMMDD");
  const end = moment(new Date()).format("YYYYMMDD");
  const [startDate, setStateDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [form] = Form.useForm();

  const [showPanel, setShowPanel] = useState(false);

  const [dates, setDates] = useState<any>({
    startDate: moment(new Date()).format("YYYYMMDD"),
    endDate: moment(new Date()).format("YYYYMMDD"),
    isRange: false,
  });

  const site = user?.site?._id || "6224dcf60c5c49d9fec9218f";

  const handleFetchData = async ({ dates }: any) => {
    setLoading(true);
    const uri = `bookings/wall/${site}?start=${dates?.startDate}&end=${dates?.endDate}`;
    const response = await fetchDataTrace({
      uri,
      token,
      expire,
    });
    if (response?.success) {
      setBookings(response?.payload);
    }
    setLoading(false);
  };

  const handleFetchBookings = async () => {
    setLoading(true);
    const uri = `bookings/wall/${
      site || "6224dcf60c5c49d9fec9218f"
    }?start=${startDate}&end=${endDate}`;
    const data = await fetchDataTrace({ uri, token, expire });
    setBookings(data?.payload);
    setLoading(false);
  };

  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
    setDates({
      startDate: moment(new Date(date)).format("YYYYMMDD"),
      endDate: moment(new Date(date)).format("YYYYMMDD"),
      isRange: false,
    });

    handleFetchData({
      dates: {
        startDate: moment(new Date(date)).format("YYYYMMDD"),
        endDate: moment(new Date(date)).format("YYYYMMDD"),
        isRange: false,
      },
    });
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
    setDates({
      startDate: moment(new Date(date[0])).format("YYYYMMDD"),
      endDate: moment(new Date(date[1])).format("YYYYMMDD"),
      isRange: true,
    });

    handleFetchData({
      dates: {
        startDate: moment(new Date(date[0])).format("YYYYMMDD"),
        endDate: moment(new Date(date[1])).format("YYYYMMDD"),
        isRange: true,
      },
    });
  };

  const clearDate = () => {
    form.resetFields();
    const start = moment().startOf("isoWeek").format("YYYYMMDD");
    const end = moment().endOf("isoWeek").format("YYYYMMDD");
    setStateDate(start);
    setEndDate(end);
    setDates({
      startDate: moment(new Date()).format("YYYYMMDD"),
      endDate: moment(new Date()).format("YYYYMMDD"),
      isRange: false,
    });
    handleFetchData({
      dates: {
        startDate: moment(new Date()).format("YYYYMMDD"),
        endDate: moment(new Date()).format("YYYYMMDD"),
        isRange: false,
      },
    });
  };

  useEffect(() => {
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      handleFetchBookings();

      Toastify({
        text: `New Booking Created`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    book.bind("confirm", function (data: any) {
      handleFetchBookings();
    });

    return () => {
      pusher.unsubscribe("booking");
    };
  }, []);

  useEffect(() => {
    handleFetchData({ dates });
  }, [dates]);

  let columns = [
    {
      title: "S/N",
      width: 50,
      dataIndex: "",
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Customer",
      width: 150,
      dataIndex: "",
      render: (record: any) => (
        <div className="w-full">
          {record?.customer_code === 0 ? (
            <div className="text-gray-700 bg-red-200 px-2 py-1 w-full">
              <span className="mr-2"> Guest:</span>
              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          ) : (
            <div className="px-2 py-1">
              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Requested",
      width: 90,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.createdAt === null ? (
            "-"
          ) : (
            <Moment fromNow>{record?.createdAt}</Moment>
          )}
        </span>
      ),
    },
    {
      title: "Vehicle",
      width: 80,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex flex-col">
          <span className="text-gray-700">
            {record?.vehicle === null ? "-" : record?.vehicle}
          </span>
        </div>
      ),
    },
    {
      title: "Model",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.model_year === null ? "" : record?.model_year}{" "}
          {record?.model === null ? "-" : record?.model}
        </span>
      ),
    },
    {
      title: "Mileage",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.mileage === null || record?.mileage === ""
            ? "-"
            : `${formatNumber(Number(record?.mileage))} Km`}
        </div>
      ),
    },

    {
      title: "Date",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.date === undefined || record?.date === null ? (
            "-"
          ) : (
            <>
              <Moment format="Do MMM, YYYY">{record?.date}</Moment>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Time",
      width: 140,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.date === undefined || record?.date === null ? (
            "-"
          ) : (
            <>
              {record?.slottime === null ? (
                "-"
              ) : (
                <>
                  <Moment format="HH:mm A">
                    {record?.slottime?.starttime}
                  </Moment>
                  <span className="mx-1">-</span>
                  <Moment format="HH:mm A">{record?.slottime?.endtime}</Moment>
                </>
              )}
            </>
          )}
        </span>
      ),
    },
    {
      title: "Booking No.",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="ml-1">
            {record?.bookingno ? record?.bookingno : "-"}
          </span>
        </div>
      ),
    },
    {
      title: "WIP",
      width: 60,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex justify-center items-center text-gray-700">
          <span className="">{record?.wip ? record?.wip : "-"}</span>
        </div>
      ),
    },

    {
      title: "Advisor",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <div className="ml-1 trancate">
            {record?.assignedTo
              ? `${record?.assignedTo?.firstname.charAt(0)}.${
                  record?.assignedTo?.lastname
                }`
              : "-"}
          </div>
        </div>
      ),
    },

    {
      title: "Location",
      width: 120,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex truncate">
          <div className="flex justify-center items-center ml-1 text-blue-700 border rounded-md px-2 py-1 bg-blue-50 hover:bg-blue-50">
            <GoLocation /> <span className="ml-1">-</span>
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      width: 70,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex">
          {record.is_confirmed ? (
            <div className="bg-status-green font-bold px-2 py-1 rounded-md text-center text-white w-full flex items-center justify-center">
              <BsCheckSquare /> <span className="ml-1">CONFIRMED</span>
            </div>
          ) : (
            <div className="bg-status-red text-white font-bold px-2 py-1 rounded-md text-center w-full">
              <span>UNCONFIRMED</span>
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="h-16 bg-toyota flex items-center justify-between px-2">
        <div className="flex items-center font-bold">
          <div className="">
            <img src={logo} alt="" width={52} />
          </div>
          <div className="ml-2 text-white text-xl ">BOOKINGS</div>

          <div className=" text-white text-lg uppercase border-l pl-2 ml-2">
            {dates?.isRange ? (
              <div className="">
                <Moment format={"Do MMMM YYYY"}>{dates?.startDate}</Moment>
                <span className="px-2">-</span>
                <Moment format={"Do MMMM YYYY"}>{dates?.endDate}</Moment>
              </div>
            ) : (
              <div className="">
                <Moment format={"Do MMMM YYYY"}>{dates?.startDate}</Moment>
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center font-bold">
          <div className="mr-2 text-white pb-1">
            {user?.site?.name || "Toyota HQ ( Dar es salaam )"}
          </div>
          <Link to="/">
            <IoIosLogIn size={30} color="#FFFFFF" />
          </Link>
        </div>
      </div>
      <div className="bg-gray-50 border-b border-gray-300 px-2 py-1 flex items-center justify-between">
        <Form layout="inline" form={form}>
          {showRange ? (
            <div className="flex justify-center items-center">
              <Form.Item name="ranger">
                <RangePicker
                  allowClear={true}
                  onChange={onRangeChange}
                  format={"DD-MM-YYYY"}
                />
              </Form.Item>

              <Checkbox onChange={() => setShowRange(!showRange)}>
                <span className="text-gray-500">Date as Range</span>
              </Checkbox>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <Form.Item name="picker">
                <DatePicker
                  onChange={onDateChange}
                  format={"DD-MM-YYYY"}
                  placeholder="Specific date"
                  className=" border-gray-300"
                />
              </Form.Item>
              <Checkbox onChange={() => setShowRange(!showRange)}>
                <span className="text-gray-500">Date as Range</span>
              </Checkbox>
            </div>
          )}
          <Button className="" onClick={() => clearDate()}>
            <RiFilterOffLine color="#6b7280" />
          </Button>
        </Form>
        <Link to="/bookings/calendar" className="">
          <BsCalendar4Event color={"#323232"} size={20} />
        </Link>
      </div>

      <div className="flex flex-col px-2 rounded-lg bg-white">
        <div className="grid gap-x-0 grid-cols-12">
          <div className="col-span-12 sm:col-span-12 md:col-span-12">
            <Table
              columns={columns}
              dataSource={bookings}
              size="small"
              pagination={false}
              rowKey="id"
              loading={isLoading}
            />

            <CreateBooking
              isVisible={createModal}
              setCreateModal={setCreateModal}
            />

            <ConfirmBooking
              selected={selected}
              isVisible={confirmModal}
              setConfirmModal={setConfirmModal}
              handleFetchBookings={handleFetchBookings}
            />

            <RescheduleBooking
              selected={selected}
              isVisible={rescheduleModal}
              setConfirmModal={setRescheduleModal}
              refetch={handleFetchBookings}
            />

            <UpdateWip
              selected={selected}
              isVisible={wipModal}
              setVisible={setWipModal}
              handleFetchBookings={handleFetchBookings}
            />

            <DeleteBoooking
              selected={selected}
              isVisible={deleteModal}
              setVisible={setDeleteModal}
              refetch={handleFetchBookings}
            />

            <DetailsPanel
              isVisible={showPanel}
              setVisible={setShowPanel}
              selected={selected}
            />
          </div>
        </div>
      </div>
    </>
  );
}
